import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

interface UpcomingPaymentsMiniCardThumbnailProps {
  isHovered?: boolean;
  alwaysVisible?: boolean;
}

export default function UpcomingPaymentsMiniCardThumbnail({ 
  isHovered = false, 
  alwaysVisible = false 
}: UpcomingPaymentsMiniCardThumbnailProps) {
  const baseScale = alwaysVisible ? 'scale-[0.4]' : 'scale-100';
  const hoverScale = isHovered ? 'scale-100' : baseScale;

  return (
    <div className={`transition-transform duration-300 origin-left ${hoverScale} ${isHovered ? 'z-50' : ''}`}>
      <Card className="w-[300px] shadow-sm">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-medium text-muted-foreground">
            Upcoming Payments
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">23</div>
          <div className="text-xs text-muted-foreground mt-1">
            £145,600 next 90 days
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
